import { HttpQueryConfig } from '../../core/model/HttpQueryConfig.model';

export const ItsmHttpQueryConfig: HttpQueryConfig = {
  GetItsmMaintenanceWorks: {
    key: 'GetItsmMaintenanceWorks',
    url: '/api/customers/{customerId}/itsm-maintenance-works',
    errors: {},
  },
  GetItsmNetworkServiceIncidents: {
    key: 'GetItsmNetworkServiceIncidents',
    url: '/api/customers/{customerId}/itsm-network-service-incidents',
    errors: {}
  },
};
